import { Link } from 'react-router-dom';
import { ArrowRight, MessageCircle } from 'lucide-react';
import styles from './CTA.module.css';

export default function CTA() {
	return (
		<section className={styles.cta}>
			<div className={styles.background}>
				<div className={styles.gradient} />
				<div className={styles.pattern} />
			</div>

			<div className={styles.container}>
				<div className={styles.content}>
					<h2 className={styles.title}>
						Ready to Launch Your Crypto Casino?
					</h2>
					<p className={styles.subtitle}>
						Get started with our comprehensive documentation or contact our team
						for a personalized demo. Launch your first game in under an hour.
					</p>

					<div className={styles.actions}>
						<Link to="/docs/quickstart" className={styles.primaryButton}>
							Get Started Free
							<ArrowRight size={18} />
						</Link>
						<a
							href="mailto:sales@ringfort.studio"
							className={styles.secondaryButton}
						>
							<MessageCircle size={18} />
							Contact Sales
						</a>
					</div>

					<p className={styles.note}>
						No credit card required. Start integrating today.
					</p>
				</div>
			</div>
		</section>
	);
}
